// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../src/assets/fonts/webfonts/Vazirmatn-Thin.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../src/assets/fonts/ttf/Vazirmatn-Thin.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../src/assets/fonts/webfonts/Vazirmatn-ExtraLight.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../src/assets/fonts/ttf/Vazirmatn-ExtraLight.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../src/assets/fonts/webfonts/Vazirmatn-Light.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("../src/assets/fonts/ttf/Vazirmatn-Light.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("../src/assets/fonts/webfonts/Vazirmatn-Regular.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("../src/assets/fonts/ttf/Vazirmatn-Regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("../src/assets/fonts/webfonts/Vazirmatn-Medium.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_9___ = new URL("../src/assets/fonts/ttf/Vazirmatn-Medium.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_10___ = new URL("../src/assets/fonts/webfonts/Vazirmatn-SemiBold.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_11___ = new URL("../src/assets/fonts/ttf/Vazirmatn-SemiBold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_12___ = new URL("../src/assets/fonts/webfonts/Vazirmatn-Bold.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_13___ = new URL("../src/assets/fonts/ttf/Vazirmatn-Bold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_14___ = new URL("../src/assets/fonts/webfonts/Vazirmatn-ExtraBold.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_15___ = new URL("../src/assets/fonts/ttf/Vazirmatn-ExtraBold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_16___ = new URL("../src/assets/fonts/webfonts/Vazirmatn-Black.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_17___ = new URL("../src/assets/fonts/ttf/Vazirmatn-Black.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
var ___CSS_LOADER_URL_REPLACEMENT_9___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_9___);
var ___CSS_LOADER_URL_REPLACEMENT_10___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_10___);
var ___CSS_LOADER_URL_REPLACEMENT_11___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_11___);
var ___CSS_LOADER_URL_REPLACEMENT_12___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_12___);
var ___CSS_LOADER_URL_REPLACEMENT_13___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_13___);
var ___CSS_LOADER_URL_REPLACEMENT_14___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_14___);
var ___CSS_LOADER_URL_REPLACEMENT_15___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_15___);
var ___CSS_LOADER_URL_REPLACEMENT_16___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_16___);
var ___CSS_LOADER_URL_REPLACEMENT_17___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_17___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
	margin: 0;
	padding: 0;
	box-sizing: border-box;
}

@font-face {
	font-family: "Vazir";
	src: url(${___CSS_LOADER_URL_REPLACEMENT_0___})
			format("woff2"),
		url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("ttf");
	font-weight: 100;
	font-style: normal;
}

@font-face {
	font-family: "Vazir";
	src: url(${___CSS_LOADER_URL_REPLACEMENT_2___})
			format("woff2"),
		url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format("ttf");
	font-weight: 200;
	font-style: normal;
}

@font-face {
	font-family: "Vazir";
	src: url(${___CSS_LOADER_URL_REPLACEMENT_4___})
			format("woff2"),
		url(${___CSS_LOADER_URL_REPLACEMENT_5___}) format("ttf");
	font-weight: 300;
	font-style: normal;
}

@font-face {
	font-family: "Vazir";
	src: url(${___CSS_LOADER_URL_REPLACEMENT_6___})
			format("woff2"),
		url(${___CSS_LOADER_URL_REPLACEMENT_7___}) format("ttf");
	font-weight: 400;
	font-style: normal;
}

@font-face {
	font-family: "Vazir";
	src: url(${___CSS_LOADER_URL_REPLACEMENT_8___})
			format("woff2"),
		url(${___CSS_LOADER_URL_REPLACEMENT_9___}) format("ttf");
	font-weight: 500;
	font-style: normal;
}

@font-face {
	font-family: "Vazir";
	src: url(${___CSS_LOADER_URL_REPLACEMENT_10___})
			format("woff2"),
		url(${___CSS_LOADER_URL_REPLACEMENT_11___}) format("ttf");
	font-weight: 600;
	font-style: normal;
}

@font-face {
	font-family: "Vazir";
	src: url(${___CSS_LOADER_URL_REPLACEMENT_12___})
			format("woff2"),
		url(${___CSS_LOADER_URL_REPLACEMENT_13___}) format("ttf");
	font-weight: 700;
	font-style: normal;
}

@font-face {
	font-family: "Vazir";
	src: url(${___CSS_LOADER_URL_REPLACEMENT_14___})
			format("woff2"),
		url(${___CSS_LOADER_URL_REPLACEMENT_15___}) format("ttf");
	font-weight: 800;
	font-style: normal;
}

@font-face {
	font-family: "Vazir";
	src: url(${___CSS_LOADER_URL_REPLACEMENT_16___})
			format("woff2"),
		url(${___CSS_LOADER_URL_REPLACEMENT_17___}) format("ttf");
	font-weight: 900;
	font-style: normal;
}

body {
	font-family: "Vazir", sans-serif;
	font-weight: 400;
	color: var(--dark-gray);
	line-height: 1.6;
	-webkit-font-smoothing: antialiased;
	-moz-osx-font-smoothing: grayscale;
	background: linear-gradient(180deg, #f2f5f8, #5a8dc0);
}

.container {
	display: flex;
	justify-content: center;
	align-items: center;
	margin-top: 100px;
	min-height: calc(100vh - 100px);
}

.container.without-navbar {
	min-height: 100vh;
	margin-top: 0;
}

h1,
h2,
h3,
h4,
h5,
h6 {
	font-weight: bold;
	margin-bottom: 10px;
}

.thin-text {
	font-family: "Vazir", sans-serif;
	font-weight: 100;
}

.extra-light-text {
	font-family: "Vazir", sans-serif;
	font-weight: 200;
}

.light-text {
	font-family: "Vazir", sans-serif;
	font-weight: 300;
}

.regular-text {
	font-family: "Vazir", sans-serif;
	font-weight: 400;
}

.medium-text {
	font-family: "Vazir", sans-serif;
	font-weight: 500;
}

.semi-bold-text {
	font-family: "Vazir", sans-serif;
	font-weight: 600;
}

.bold-text {
	font-family: "Vazir", sans-serif;
	font-weight: 700;
}

.extra-bold-text {
	font-family: "Vazir", sans-serif;
	font-weight: 800;
}

.black-text {
	font-family: "Vazir", sans-serif;
	font-weight: 900;
}

p {
	margin-bottom: 15px;
	line-height: 1.8;
}

a {
	text-decoration: none;
	color: var(--primary-color);
	transition: color 0.3s;
}

a:hover {
	color: #000;
}

.btn {
	background-color: var(--primary-color);
	height: 50px;
	color: var(--white);
	border: none;
	border-radius: 5px;
	cursor: pointer;
	transition: background-color 0.3s;
}

.btn:hover {
	background-color: var(--primary-hover);
}

.btn.disabled {
	background-color: #cccccc;
	cursor: not-allowed;
}

.row {
	display: flex;
	flex-wrap: wrap;
	margin: -10px;
}

.col {
	flex: 1 1;
	padding: 10px;
}

.col-1 {
	flex: 0 0 8.33%;
}
.col-2 {
	flex: 0 0 16.66%;
}
.col-3 {
	flex: 0 0 25%;
}
.col-4 {
	flex: 0 0 33.33%;
}
.col-5 {
	flex: 0 0 41.66%;
}
.col-6 {
	flex: 0 0 50%;
}
.col-7 {
	flex: 0 0 58.33%;
}
.col-8 {
	flex: 0 0 66.66%;
}
.col-9 {
	flex: 0 0 75%;
}
.col-10 {
	flex: 0 0 83.33%;
}
.col-11 {
	flex: 0 0 91.66%;
}
.col-12 {
	flex: 0 0 100%;
}

:root {
	--primary-color: #0c3d6e;
	--secondary-color: #b6cee7;
	--primary-hover: #0c3d8f;
	--secondary-hover: #a9c5e3;
	--light-gray: #f8f9fa;
	--dark-gray: #333;
	--white: #fff;
	--label-color: #666666;
	--danger-color: #ff0800;
	--success-color: #0ab129;
	--home-primary-color: #0ea77c;
	--home-secondary-color: #007bff;
}

.card {
	background-color: var(--primary-color);
	border: 1px solid #ddd;
	border-radius: 10px;
	box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
	padding: 20px;
}

.card-header {
	background-color: var(--primary-color);
	color: var(--white);
	padding: 10px 15px;
	font-size: 1.2rem;
	font-weight: bold;
	border-bottom: 1px solid #ddd;
}

.card-body {
	padding: 15px;
}

label {
	display: block;
	color: var(--label-color);
}

input,
textarea,
select {
	width: 100%;
	height: 50px;
	padding: 10px;
	margin-bottom: 15px;
	border: 1px solid #ccc;
	border-radius: 5px;
	font-size: 20px;
	transition: box-shadow 0.3s, border-color 0.3s;
	font-family: "Vazir", sans-serif;
}

input:focus,
textarea:focus,
select:focus {
	outline: none;
	border-color: var(--primary-color);
	box-shadow: 0 0 5px rgba(12, 61, 110, 0.5);
}

input:not([value=""]):not(input:focus),
input:disabled {
	background-color: rgb(232, 240, 254);
}

.table-container {
    overflow-x: auto;
    width: 100%;
}

table {
    width: 100%;
    table-layout: fixed;
}

td {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 0;
}

.table {
	width: 100%;
	border-collapse: collapse;
	margin-bottom: 20px;
}

.table th,
.table td {
	padding: 10px;
	border: 1px solid #ddd;
	text-align: left;
}

.table th {
	background-color: var(--light-gray);
	font-weight: bold;
}

.pagination {
	display: flex;
	justify-content: center;
	margin: 20px 0;
}

.pagination .page-link {
	padding: 8px 12px;
	margin: 0 5px;
	border: 1px solid var(--primary-color);
	border-radius: 4px;
	color: var(--primary-color);
	text-decoration: none;
	transition: background-color 0.3s, color 0.3s;
}

.pagination .page-link:hover {
	background-color: var(--primary-color);
	color: var(--white);
}

.text-center {
	text-align: center;
}
.text-right {
	text-align: right;
}
.text-left {
	text-align: left;
}

.mt-0 {
	margin-top: 0;
}
.mt-1 {
	margin-top: 5px;
}
.mt-2 {
	margin-top: 10px;
}
.mt-3 {
	margin-top: 15px;
}
.mt-4 {
	margin-top: 20px;
}

.mb-0 {
	margin-bottom: 0;
}
.mb-1 {
	margin-bottom: 5px;
}
.mb-2 {
	margin-bottom: 10px;
}
.mb-3 {
	margin-bottom: 15px;
}
.mb-4 {
	margin-bottom: 20px;
}

.pt-0 {
	padding-top: 0;
}
.pt-1 {
	padding-top: 5px;
}
.pt-2 {
	padding-top: 10px;
}
.pt-3 {
	padding-top: 15px;
}
.pt-4 {
	padding-top: 20px;
}

.pb-0 {
	padding-bottom: 0;
}
.pb-1 {
	padding-bottom: 5px;
}
.pb-2 {
	padding-bottom: 10px;
}
.pb-3 {
	padding-bottom: 15px;
}
.pb-4 {
	padding-bottom: 20px;
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;CACC,SAAS;CACT,UAAU;CACV,sBAAsB;AACvB;;AAEA;CACC,oBAAoB;CACpB;;uDAEgE;CAChE,gBAAgB;CAChB,kBAAkB;AACnB;;AAEA;CACC,oBAAoB;CACpB;;uDAEsE;CACtE,gBAAgB;CAChB,kBAAkB;AACnB;;AAEA;CACC,oBAAoB;CACpB;;uDAEiE;CACjE,gBAAgB;CAChB,kBAAkB;AACnB;;AAEA;CACC,oBAAoB;CACpB;;uDAEmE;CACnE,gBAAgB;CAChB,kBAAkB;AACnB;;AAEA;CACC,oBAAoB;CACpB;;uDAEkE;CAClE,gBAAgB;CAChB,kBAAkB;AACnB;;AAEA;CACC,oBAAoB;CACpB;;wDAEoE;CACpE,gBAAgB;CAChB,kBAAkB;AACnB;;AAEA;CACC,oBAAoB;CACpB;;wDAEgE;CAChE,gBAAgB;CAChB,kBAAkB;AACnB;;AAEA;CACC,oBAAoB;CACpB;;wDAEqE;CACrE,gBAAgB;CAChB,kBAAkB;AACnB;;AAEA;CACC,oBAAoB;CACpB;;wDAEiE;CACjE,gBAAgB;CAChB,kBAAkB;AACnB;;AAEA;CACC,gCAAgC;CAChC,gBAAgB;CAChB,uBAAuB;CACvB,gBAAgB;CAChB,mCAAmC;CACnC,kCAAkC;CAClC,qDAAqD;AACtD;;AAEA;CACC,aAAa;CACb,uBAAuB;CACvB,mBAAmB;CACnB,iBAAiB;CACjB,+BAA+B;AAChC;;AAEA;CACC,iBAAiB;CACjB,aAAa;AACd;;AAEA;;;;;;CAMC,iBAAiB;CACjB,mBAAmB;AACpB;;AAEA;CACC,gCAAgC;CAChC,gBAAgB;AACjB;;AAEA;CACC,gCAAgC;CAChC,gBAAgB;AACjB;;AAEA;CACC,gCAAgC;CAChC,gBAAgB;AACjB;;AAEA;CACC,gCAAgC;CAChC,gBAAgB;AACjB;;AAEA;CACC,gCAAgC;CAChC,gBAAgB;AACjB;;AAEA;CACC,gCAAgC;CAChC,gBAAgB;AACjB;;AAEA;CACC,gCAAgC;CAChC,gBAAgB;AACjB;;AAEA;CACC,gCAAgC;CAChC,gBAAgB;AACjB;;AAEA;CACC,gCAAgC;CAChC,gBAAgB;AACjB;;AAEA;CACC,mBAAmB;CACnB,gBAAgB;AACjB;;AAEA;CACC,qBAAqB;CACrB,2BAA2B;CAC3B,sBAAsB;AACvB;;AAEA;CACC,WAAW;AACZ;;AAEA;CACC,sCAAsC;CACtC,YAAY;CACZ,mBAAmB;CACnB,YAAY;CACZ,kBAAkB;CAClB,eAAe;CACf,iCAAiC;AAClC;;AAEA;CACC,sCAAsC;AACvC;;AAEA;CACC,yBAAyB;CACzB,mBAAmB;AACpB;;AAEA;CACC,aAAa;CACb,eAAe;CACf,aAAa;AACd;;AAEA;CACC,SAAO;CACP,aAAa;AACd;;AAEA;CACC,eAAe;AAChB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,aAAa;AACd;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,aAAa;AACd;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,aAAa;AACd;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,cAAc;AACf;;AAEA;CACC,wBAAwB;CACxB,0BAA0B;CAC1B,wBAAwB;CACxB,0BAA0B;CAC1B,qBAAqB;CACrB,iBAAiB;CACjB,aAAa;CACb,sBAAsB;CACtB,uBAAuB;CACvB,wBAAwB;CACxB,6BAA6B;CAC7B,+BAA+B;AAChC;;AAEA;CACC,sCAAsC;CACtC,sBAAsB;CACtB,mBAAmB;CACnB,wCAAwC;CACxC,aAAa;AACd;;AAEA;CACC,sCAAsC;CACtC,mBAAmB;CACnB,kBAAkB;CAClB,iBAAiB;CACjB,iBAAiB;CACjB,6BAA6B;AAC9B;;AAEA;CACC,aAAa;AACd;;AAEA;CACC,cAAc;CACd,yBAAyB;AAC1B;;AAEA;;;CAGC,WAAW;CACX,YAAY;CACZ,aAAa;CACb,mBAAmB;CACnB,sBAAsB;CACtB,kBAAkB;CAClB,eAAe;CACf,8CAA8C;CAC9C,gCAAgC;AACjC;;AAEA;;;CAGC,aAAa;CACb,kCAAkC;CAClC,0CAA0C;AAC3C;;AAEA;;CAEC,oCAAoC;AACrC;;AAEA;IACI,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;IACvB,YAAY;AAChB;;AAEA;CACC,WAAW;CACX,yBAAyB;CACzB,mBAAmB;AACpB;;AAEA;;CAEC,aAAa;CACb,sBAAsB;CACtB,gBAAgB;AACjB;;AAEA;CACC,mCAAmC;CACnC,iBAAiB;AAClB;;AAEA;CACC,aAAa;CACb,uBAAuB;CACvB,cAAc;AACf;;AAEA;CACC,iBAAiB;CACjB,aAAa;CACb,sCAAsC;CACtC,kBAAkB;CAClB,2BAA2B;CAC3B,qBAAqB;CACrB,6CAA6C;AAC9C;;AAEA;CACC,sCAAsC;CACtC,mBAAmB;AACpB;;AAEA;CACC,kBAAkB;AACnB;AACA;CACC,iBAAiB;AAClB;AACA;CACC,gBAAgB;AACjB;;AAEA;CACC,aAAa;AACd;AACA;CACC,eAAe;AAChB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;AACA;CACC,kBAAkB;AACnB;AACA;CACC,mBAAmB;AACpB;AACA;CACC,mBAAmB;AACpB;AACA;CACC,mBAAmB;AACpB;;AAEA;CACC,cAAc;AACf;AACA;CACC,gBAAgB;AACjB;AACA;CACC,iBAAiB;AAClB;AACA;CACC,iBAAiB;AAClB;AACA;CACC,iBAAiB;AAClB;;AAEA;CACC,iBAAiB;AAClB;AACA;CACC,mBAAmB;AACpB;AACA;CACC,oBAAoB;AACrB;AACA;CACC,oBAAoB;AACrB;AACA;CACC,oBAAoB;AACrB","sourcesContent":["* {\n\tmargin: 0;\n\tpadding: 0;\n\tbox-sizing: border-box;\n}\n\n@font-face {\n\tfont-family: \"Vazir\";\n\tsrc: url(\"../src/assets/fonts/webfonts/Vazirmatn-Thin.woff2\")\n\t\t\tformat(\"woff2\"),\n\t\turl(\"../src/assets/fonts/ttf/Vazirmatn-Thin.ttf\") format(\"ttf\");\n\tfont-weight: 100;\n\tfont-style: normal;\n}\n\n@font-face {\n\tfont-family: \"Vazir\";\n\tsrc: url(\"../src/assets/fonts/webfonts/Vazirmatn-ExtraLight.woff2\")\n\t\t\tformat(\"woff2\"),\n\t\turl(\"../src/assets/fonts/ttf/Vazirmatn-ExtraLight.ttf\") format(\"ttf\");\n\tfont-weight: 200;\n\tfont-style: normal;\n}\n\n@font-face {\n\tfont-family: \"Vazir\";\n\tsrc: url(\"../src/assets/fonts/webfonts/Vazirmatn-Light.woff2\")\n\t\t\tformat(\"woff2\"),\n\t\turl(\"../src/assets/fonts/ttf/Vazirmatn-Light.ttf\") format(\"ttf\");\n\tfont-weight: 300;\n\tfont-style: normal;\n}\n\n@font-face {\n\tfont-family: \"Vazir\";\n\tsrc: url(\"../src/assets/fonts/webfonts/Vazirmatn-Regular.woff2\")\n\t\t\tformat(\"woff2\"),\n\t\turl(\"../src/assets/fonts/ttf/Vazirmatn-Regular.ttf\") format(\"ttf\");\n\tfont-weight: 400;\n\tfont-style: normal;\n}\n\n@font-face {\n\tfont-family: \"Vazir\";\n\tsrc: url(\"../src/assets/fonts/webfonts/Vazirmatn-Medium.woff2\")\n\t\t\tformat(\"woff2\"),\n\t\turl(\"../src/assets/fonts/ttf/Vazirmatn-Medium.ttf\") format(\"ttf\");\n\tfont-weight: 500;\n\tfont-style: normal;\n}\n\n@font-face {\n\tfont-family: \"Vazir\";\n\tsrc: url(\"../src/assets/fonts/webfonts/Vazirmatn-SemiBold.woff2\")\n\t\t\tformat(\"woff2\"),\n\t\turl(\"../src/assets/fonts/ttf/Vazirmatn-SemiBold.ttf\") format(\"ttf\");\n\tfont-weight: 600;\n\tfont-style: normal;\n}\n\n@font-face {\n\tfont-family: \"Vazir\";\n\tsrc: url(\"../src/assets/fonts/webfonts/Vazirmatn-Bold.woff2\")\n\t\t\tformat(\"woff2\"),\n\t\turl(\"../src/assets/fonts/ttf/Vazirmatn-Bold.ttf\") format(\"ttf\");\n\tfont-weight: 700;\n\tfont-style: normal;\n}\n\n@font-face {\n\tfont-family: \"Vazir\";\n\tsrc: url(\"../src/assets/fonts/webfonts/Vazirmatn-ExtraBold.woff2\")\n\t\t\tformat(\"woff2\"),\n\t\turl(\"../src/assets/fonts/ttf/Vazirmatn-ExtraBold.ttf\") format(\"ttf\");\n\tfont-weight: 800;\n\tfont-style: normal;\n}\n\n@font-face {\n\tfont-family: \"Vazir\";\n\tsrc: url(\"../src/assets/fonts/webfonts/Vazirmatn-Black.woff2\")\n\t\t\tformat(\"woff2\"),\n\t\turl(\"../src/assets/fonts/ttf/Vazirmatn-Black.ttf\") format(\"ttf\");\n\tfont-weight: 900;\n\tfont-style: normal;\n}\n\nbody {\n\tfont-family: \"Vazir\", sans-serif;\n\tfont-weight: 400;\n\tcolor: var(--dark-gray);\n\tline-height: 1.6;\n\t-webkit-font-smoothing: antialiased;\n\t-moz-osx-font-smoothing: grayscale;\n\tbackground: linear-gradient(180deg, #f2f5f8, #5a8dc0);\n}\n\n.container {\n\tdisplay: flex;\n\tjustify-content: center;\n\talign-items: center;\n\tmargin-top: 100px;\n\tmin-height: calc(100vh - 100px);\n}\n\n.container.without-navbar {\n\tmin-height: 100vh;\n\tmargin-top: 0;\n}\n\nh1,\nh2,\nh3,\nh4,\nh5,\nh6 {\n\tfont-weight: bold;\n\tmargin-bottom: 10px;\n}\n\n.thin-text {\n\tfont-family: \"Vazir\", sans-serif;\n\tfont-weight: 100;\n}\n\n.extra-light-text {\n\tfont-family: \"Vazir\", sans-serif;\n\tfont-weight: 200;\n}\n\n.light-text {\n\tfont-family: \"Vazir\", sans-serif;\n\tfont-weight: 300;\n}\n\n.regular-text {\n\tfont-family: \"Vazir\", sans-serif;\n\tfont-weight: 400;\n}\n\n.medium-text {\n\tfont-family: \"Vazir\", sans-serif;\n\tfont-weight: 500;\n}\n\n.semi-bold-text {\n\tfont-family: \"Vazir\", sans-serif;\n\tfont-weight: 600;\n}\n\n.bold-text {\n\tfont-family: \"Vazir\", sans-serif;\n\tfont-weight: 700;\n}\n\n.extra-bold-text {\n\tfont-family: \"Vazir\", sans-serif;\n\tfont-weight: 800;\n}\n\n.black-text {\n\tfont-family: \"Vazir\", sans-serif;\n\tfont-weight: 900;\n}\n\np {\n\tmargin-bottom: 15px;\n\tline-height: 1.8;\n}\n\na {\n\ttext-decoration: none;\n\tcolor: var(--primary-color);\n\ttransition: color 0.3s;\n}\n\na:hover {\n\tcolor: #000;\n}\n\n.btn {\n\tbackground-color: var(--primary-color);\n\theight: 50px;\n\tcolor: var(--white);\n\tborder: none;\n\tborder-radius: 5px;\n\tcursor: pointer;\n\ttransition: background-color 0.3s;\n}\n\n.btn:hover {\n\tbackground-color: var(--primary-hover);\n}\n\n.btn.disabled {\n\tbackground-color: #cccccc;\n\tcursor: not-allowed;\n}\n\n.row {\n\tdisplay: flex;\n\tflex-wrap: wrap;\n\tmargin: -10px;\n}\n\n.col {\n\tflex: 1;\n\tpadding: 10px;\n}\n\n.col-1 {\n\tflex: 0 0 8.33%;\n}\n.col-2 {\n\tflex: 0 0 16.66%;\n}\n.col-3 {\n\tflex: 0 0 25%;\n}\n.col-4 {\n\tflex: 0 0 33.33%;\n}\n.col-5 {\n\tflex: 0 0 41.66%;\n}\n.col-6 {\n\tflex: 0 0 50%;\n}\n.col-7 {\n\tflex: 0 0 58.33%;\n}\n.col-8 {\n\tflex: 0 0 66.66%;\n}\n.col-9 {\n\tflex: 0 0 75%;\n}\n.col-10 {\n\tflex: 0 0 83.33%;\n}\n.col-11 {\n\tflex: 0 0 91.66%;\n}\n.col-12 {\n\tflex: 0 0 100%;\n}\n\n:root {\n\t--primary-color: #0c3d6e;\n\t--secondary-color: #b6cee7;\n\t--primary-hover: #0c3d8f;\n\t--secondary-hover: #a9c5e3;\n\t--light-gray: #f8f9fa;\n\t--dark-gray: #333;\n\t--white: #fff;\n\t--label-color: #666666;\n\t--danger-color: #ff0800;\n\t--success-color: #0ab129;\n\t--home-primary-color: #0ea77c;\n\t--home-secondary-color: #007bff;\n}\n\n.card {\n\tbackground-color: var(--primary-color);\n\tborder: 1px solid #ddd;\n\tborder-radius: 10px;\n\tbox-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n\tpadding: 20px;\n}\n\n.card-header {\n\tbackground-color: var(--primary-color);\n\tcolor: var(--white);\n\tpadding: 10px 15px;\n\tfont-size: 1.2rem;\n\tfont-weight: bold;\n\tborder-bottom: 1px solid #ddd;\n}\n\n.card-body {\n\tpadding: 15px;\n}\n\nlabel {\n\tdisplay: block;\n\tcolor: var(--label-color);\n}\n\ninput,\ntextarea,\nselect {\n\twidth: 100%;\n\theight: 50px;\n\tpadding: 10px;\n\tmargin-bottom: 15px;\n\tborder: 1px solid #ccc;\n\tborder-radius: 5px;\n\tfont-size: 20px;\n\ttransition: box-shadow 0.3s, border-color 0.3s;\n\tfont-family: \"Vazir\", sans-serif;\n}\n\ninput:focus,\ntextarea:focus,\nselect:focus {\n\toutline: none;\n\tborder-color: var(--primary-color);\n\tbox-shadow: 0 0 5px rgba(12, 61, 110, 0.5);\n}\n\ninput:not([value=\"\"]):not(input:focus),\ninput:disabled {\n\tbackground-color: rgb(232, 240, 254);\n}\n\n.table-container {\n    overflow-x: auto;\n    width: 100%;\n}\n\ntable {\n    width: 100%;\n    table-layout: fixed;\n}\n\ntd {\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    max-width: 0;\n}\n\n.table {\n\twidth: 100%;\n\tborder-collapse: collapse;\n\tmargin-bottom: 20px;\n}\n\n.table th,\n.table td {\n\tpadding: 10px;\n\tborder: 1px solid #ddd;\n\ttext-align: left;\n}\n\n.table th {\n\tbackground-color: var(--light-gray);\n\tfont-weight: bold;\n}\n\n.pagination {\n\tdisplay: flex;\n\tjustify-content: center;\n\tmargin: 20px 0;\n}\n\n.pagination .page-link {\n\tpadding: 8px 12px;\n\tmargin: 0 5px;\n\tborder: 1px solid var(--primary-color);\n\tborder-radius: 4px;\n\tcolor: var(--primary-color);\n\ttext-decoration: none;\n\ttransition: background-color 0.3s, color 0.3s;\n}\n\n.pagination .page-link:hover {\n\tbackground-color: var(--primary-color);\n\tcolor: var(--white);\n}\n\n.text-center {\n\ttext-align: center;\n}\n.text-right {\n\ttext-align: right;\n}\n.text-left {\n\ttext-align: left;\n}\n\n.mt-0 {\n\tmargin-top: 0;\n}\n.mt-1 {\n\tmargin-top: 5px;\n}\n.mt-2 {\n\tmargin-top: 10px;\n}\n.mt-3 {\n\tmargin-top: 15px;\n}\n.mt-4 {\n\tmargin-top: 20px;\n}\n\n.mb-0 {\n\tmargin-bottom: 0;\n}\n.mb-1 {\n\tmargin-bottom: 5px;\n}\n.mb-2 {\n\tmargin-bottom: 10px;\n}\n.mb-3 {\n\tmargin-bottom: 15px;\n}\n.mb-4 {\n\tmargin-bottom: 20px;\n}\n\n.pt-0 {\n\tpadding-top: 0;\n}\n.pt-1 {\n\tpadding-top: 5px;\n}\n.pt-2 {\n\tpadding-top: 10px;\n}\n.pt-3 {\n\tpadding-top: 15px;\n}\n.pt-4 {\n\tpadding-top: 20px;\n}\n\n.pb-0 {\n\tpadding-bottom: 0;\n}\n.pb-1 {\n\tpadding-bottom: 5px;\n}\n.pb-2 {\n\tpadding-bottom: 10px;\n}\n.pb-3 {\n\tpadding-bottom: 15px;\n}\n.pb-4 {\n\tpadding-bottom: 20px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
